
import React from 'react';

interface ITMGMTLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export const ITMGMTLogo: React.FC<ITMGMTLogoProps> = ({ 
  className = '',
  width = 160,
  height = 40 
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/lovable-uploads/b2c7e6b8-31c3-4217-adfa-2f88e9a995ba.png" 
        alt="IT MGMT Solutions Logo" 
        className="h-full w-auto"
        width={width}
        height={height}
        loading="eager"
      />
    </div>
  );
};
